import { BlobEntity } from '../zip.service';

export const emptyBlobEntitieMock: BlobEntity[] = [
  { filename: 'empty-entity-1' },
];

export const fullBlobEntitiesMock: Required<BlobEntity>[] = [
  { blob: new Blob(), filename: 'entity-1' },
  { blob: new Blob(), filename: 'entity-2' },
];

export const blobEntitiesMock: BlobEntity[] = [
  ...emptyBlobEntitieMock,
  ...fullBlobEntitiesMock,
];
